<div class="menu-contents">
 

    <div class="election-section">
        <div class="election-detail" *ngFor="let electionEvent of lgElectionService.electionEvents">

            <div>
                <button mat-button 
                    style="color:rgb(248, 248, 246)"
                    (click)="buttonElectionEventClick(electionEvent.electionDate)">
                    {{electionEvent.electionName}}
                    <mat-icon *ngIf="electionEvent.showCouncils===false" style="color:rgb(248, 248, 246)">
                        expand_more
                    </mat-icon>
                    <mat-icon *ngIf="electionEvent.showCouncils===true" style="color:rgb(248, 248, 246)">
                        expand_less
                    </mat-icon>
                </button>
            </div>
            <div *ngIf="electionEvent.showCouncils===true">
                <div style="margin-left: 10px; margin-bottom: 24px; min-width: 310px;">
                    <mat-chip-list class="district-chip-list">
                        <mat-chip *ngFor="let council of lge?.councils"  
                        class="district-chip"
                        (click)="clickCouncil(council)"
                        [selected]="council.councilCode==selectedCouncil?.councilCode">
                            {{council.councilName}}
                        </mat-chip>
                    </mat-chip-list>
                </div>
            </div>
        </div>
    </div>

   

</div>